module.exports = __webpack_public_path__ + "static/img/topright.e3652a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topright.png
// module id = SrOZ
// module chunks = 1